import { getApiBaseUrl } from "../data/authStorage";
import httpClient from "./httpClient";

const baseUrl = getApiBaseUrl();

const unwrapError = (error) => {
  throw error.response?.data || error;
};

export async function getAttendanceSettings() {
  try {
    const response = await httpClient.get(`${baseUrl}/organizations/attendance/settings`);
    return response.data;
  } catch (error) {
    return unwrapError(error);
  }
}

export async function updateAttendanceSettings(payload) {
  try {
    const response = await httpClient.patch(`${baseUrl}/organizations/attendance/settings`, payload);
    return response.data;
  } catch (error) {
    return unwrapError(error);
  }
}

export async function updateEmployeeAttendanceWorkDays(employeeId, payload) {
  const response = await httpClient.patch(`${baseUrl}/organizations/attendance/employees/${encodeURIComponent(employeeId)}/work-days`, payload);
  return response.data;
}

export async function getTodayAttendance() {
  try {
    const response = await httpClient.get(`${baseUrl}/organizations/attendance/today`);
    return response.data;
  } catch (error) {
    return unwrapError(error);
  }
}

export async function listAttendanceOverview(params = {}) {
  try {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value);
      }
    });
    const response = await httpClient.get(
      `${baseUrl}/organizations/attendance/overview${searchParams.toString() ? `?${searchParams}` : ""}`,
    );
    return response.data;
  } catch (error) {
    return unwrapError(error);
  }
}

export async function checkInAttendance(payload = {}) {
  try {
    const response = await httpClient.post(`${baseUrl}/organizations/attendance/check-in`, payload);
    return response.data;
  } catch (error) {
    return unwrapError(error);
  }
}

export async function checkOutAttendance(payload = {}) {
  try {
    const response = await httpClient.post(`${baseUrl}/organizations/attendance/check-out`, payload);
    return response.data;
  } catch (error) {
    return unwrapError(error);
  }
}

export async function getAttendanceAnalytics(employeeId, params = {}) {
  try {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value);
      }
    });
    const response = await httpClient.get(
      `${baseUrl}/organizations/attendance/analytics/${encodeURIComponent(employeeId)}${searchParams.toString() ? `?${searchParams}` : ""}`,
    );
    return response.data;
  } catch (error) {
    return unwrapError(error);
  }
}

export async function getAttendanceHighlights() {
  try {
    const response = await httpClient.get(`${baseUrl}/organizations/attendance/highlights`);
    return response.data;
  } catch (error) {
    return unwrapError(error);
  }
}

export async function getOrganizationAttendanceAnalytics(params = {}) {
  try {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value) searchParams.set(key, value);
    });
    const response = await httpClient.get(
      `${baseUrl}/organizations/attendance/organization-analytics${searchParams.toString() ? `?${searchParams}` : ""}`,
    );
    return response.data;
  } catch (error) {
    return unwrapError(error);
  }
}
